import { useState } from "react";
import { Button, Col, Flex, Modal, Row, Typography } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { useRouterContext } from "@refinedev/core";

import classes from "./DocumentDisplay.module.css";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export const DocumentDisplay = ({
	title,
	content,
	onEdit,
	onDelete,
}: {
	title: string;
	content: string;
	onEdit?: () => void;
	onDelete?: () => void;
}) => {
	const [visible, setVisible] = useState(false);
	const navigate = useNavigate();
	return (
		<Row>
			<Col
				xs={{ span: 5 }}
				sm={{ span: 5 }}
				md={{ span: 6 }}
				lg={{ span: 6 }}
				xl={{ span: 5 }}
			></Col>
			<Col span={15}>
				<Row>
					<Col
						span={24}
						// className={classes.heading}
					>
						<Flex
							style={{
								flexDirection: "row",
								alignContent: "center",
								justifyContent: "start",
							}}
						>
							<h2
								className={classes.title}
								style={{ color: "white" }}
							>
								Documentation
							</h2>
							{onEdit && onDelete && (
								<PlusCircleOutlined
									onClick={() => navigate(`/admin/docs/new`)}
									className={classes.addBtn}
								/>
							)}
						</Flex>
					</Col>
					<Col className={classes.headingContainer} span={24}>
						<Row>
							<Typography.Title style={{ color: "white" }}>{title}</Typography.Title>
							{onEdit && onDelete && (
								<>
									<EditOutlined
										onClick={onEdit}
										className={classes.icon}
									/>
									<DeleteOutlined
										onClick={() => setVisible(true)}
										className={classes.icon}
									/>
								</>
							)}
						</Row>
					</Col>
					<Row className={classes.content}>
						<p dangerouslySetInnerHTML={{ __html: content }} />
					</Row>

					<Modal
						open={visible}
						closable={false}
						width={"fit-content"}
						footer={null}
						bodyStyle={{
							backgroundColor: "#fffbfe",
							borderRadius: 10,
						}}
					>
						<Row className={classes.logoutTitle} justify="center">
							Delete
						</Row>
						<Row justify="center">
							Are you sure you want to delete this doc?
						</Row>
						<Row className={classes.confirmation} justify="end">
							<Button
								className={classes.button}
								onClick={() => setVisible(false)}
							>
								No
							</Button>
							<Button
								onClick={onDelete}
								className={classes.button}
							>
								Yes
							</Button>
						</Row>
					</Modal>
				</Row>
			</Col>
		</Row>
	);
};
